import { FC } from "react";
import { Button, ButtonProps, Grid } from "antd";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "src/assets/Icons";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";

const SearchSubmit: FC<ButtonProps> = ({ className, ...props }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return (
    <Button
      htmlType="submit"
      className={cn("bg-background-primary! text-icon-inverted! border-none! font-semibold! w-full! h-full! max-h-14",className)}
      classNames={{
        icon:"flex! items-center! justify-center! w-full! h-full!"
      }}
      icon={isLargeScreen && <SearchIcon className="w-5 h-5" strokeWidth={1.5}/>}
      {...props}
    >
      {!isLargeScreen && t("Flights.search.search")}
    </Button>
  );
};

export default SearchSubmit;
